/**
 电站运行看板-故障
 */

import React, { Component } from "react";
import { Modal, Tooltip } from "antd";
import {
  getCityList,
  userManagerRegionList,
  queryFaultAreaNumCityQry,
  qryErrorNumByArea,
  qryErrorNumListByArea,
} from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import FormCore from "@/components/display/form/formCore";
import moment from "moment";
import PropTypes from "prop-types";
import ErrorCountPl from "@/pages/displayBoard/errorCountPl";
import PeopleCountModel from "@/pages/displayBoard/peopleCountModel";
import ErrorTop10 from "@/pages/displayBoard/errorTop10";
import ErrorGroup from "@/pages/displayBoard/errorGroup";
import { RightOutlined } from "@ant-design/icons";
import ErrorCityModal from "../configurationManagement/stub/errorCityModal";

// css
import "@/assets/stylus/displayBoard.styl";
// icon
import { QuestionCircleFilled } from "@ant-design/icons";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class ErrorPlat extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;

    this.state = {
      firmwareDataList: [],
      firmwareLoading: false,
      pieData: [],
      barData: [],
      peopleData: [],
      userList: [
        {
          text: "全部",
          value: "",
        },
      ],
      companyList: [
        {
          text: "全部",
          value: "",
        },
      ],
      cityTypeList: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "A类",
          value: "1",
        },
        {
          text: "B类",
          value: "2",
        },
        {
          text: "C类",
          value: "3",
        },
      ],
      ticketTypeList: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "非直营",
          value: "0",
        },
        {
          text: "直营",
          value: "1",
        },
      ],
      levelTypeList: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "交流电",
          value: "0",
        },
        {
          text: "直流电",
          value: "1",
        },
        {
          text: "交直流",
          value: "2",
        },
      ],
      areaList: [
        {
          text: "全部",
          value: "",
        },
      ],
      param: {
        cityIds: "",
        provinceIds: "000000", // 默认 000000全国
        date: "",
        operationProperty: "3",
        areaIds: "",
        chooseDate: [moment(new Date()).subtract(7, "d"), moment(new Date()).subtract(1, "d")], // 选择的日期
        startTime: moment(new Date()).subtract(7, "d").format("YYYY-MM-DD"),
        endTime: moment(new Date()).subtract(1, "d").format("YYYY-MM-DD"),
      },
      equipmentQry: {
        station: 0, // 桩群数量
        powerBox: 0, // 配电柜数量
        stub: 0, // 桩数量
      },
      successRate: "0",
      stubIntactRate: "0",
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  // 页面加载前方法
  componentWillMount() {
    this.setState({
      formConfig: this.initForm(),
    });
    this.getCityList();
    this.getEquipmentQry();
    this.getTop10();
    this.getAreaList();
  }

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }
  // 页面加载完成方法
  componentDidMount() {}

  //
  getModalData(type, totalNum) {
    if (
      this.state.param.infoType != null &&
      (this.state.param.cityIds == null || this.state.param.cityIds == "") &&
      (this.state.param.provinceIds == null || this.state.param.provinceIds == "")
    ) {
      return;
    }
    fetchHandler(queryFaultAreaNumCityQry, {
      type: type,
      operationMode: this.state.param.operationMode,
      stubType: this.state.param.stubType,
      cityIds: this.state.param.cityIds,
      provinceIds: this.state.param.provinceIds,
      startTime: this.state.param.startTime,
      endTime: this.state.param.endTime,
    }).then((res) => {
      if (res.data) {
        var list = [];
        var fAreaId = null;
        var index = 0;
        if (res.data.areaNums && res.data.areaNums.length > 0) {
          res.data.areaNums.forEach(function (item) {
            var one = {};
            one.id = item.id;
            one.text = item.name;
            one.num = item.stationNum;
            if (index == 0) {
              fAreaId = item.id;
              one.choosed = 2;
            } else {
              one.choosed = 1;
            }
            index++;
            list.push(one);
          });
        }

        this.setState(
          {
            areaDTOList: list,
            fAreaId: fAreaId,
            modalType: type,
            modalTitle: "故障设备总数",
            modalStationNum: totalNum,
            modalStationTitle: list.length > 0 ? list[0].text : "",
          },
          () => {
            this.setState({
              areaDTOList: list,
              fAreaId: fAreaId,
              modalTitle: "故障设备总数",
              modalType: type,
              modalStationNum: totalNum,
              modalStationTitle: list.length > 0 ? list[0].text : "",
            });
            this.modalVisibleAction("statusLogVisible", true);
          },
        );
      }
    });
  }

  /**
   * 获取充电成功率数字
   */
  getSuccessRate = (value) => {
    this.setState({
      successRate: value,
    });
  };

  /**
   * 获取设备完好率数字
   */
  getStubIntactRate = (value) => {
    this.setState({
      stubIntactRate: value,
    });
  };

  /**
   * 获取负责的大区列表
   */
  getAreaList() {
    let that = this;
    fetchHandler(userManagerRegionList, {
      userId: sessionStorage.getItem("userId"),
    }).then((res) => {
      if (res.data) {
        res.data.forEach(function (item) {
          item.text = item.regName;
          item.value = item.areaId;
        });
        res.data.unshift({
          text: "全部",
          value: "",
        });
        this.setState(
          {
            areaList: res.data,
          },
          () => {
            this.setState({
              formConfig: this.initForm(),
            });
          },
        );
      }
    });
  }

  /**
   * 获取故障累计数据
   */
  getEquipmentQry() {
    if (
      this.state.param.infoType != null &&
      (this.state.param.cityIds == null || this.state.param.cityIds == "") &&
      (this.state.param.provinceIds == null || this.state.param.provinceIds == "")
    ) {
      this.setState({
        monthDataList: [],
        comEvHandleNum: 0,
        evHandleNum: 0,
        handleNum: 0,
        finishNum: 0,
        newNum: 0,
      });
      return;
    }
    fetchHandler(qryErrorNumByArea, {
      operationMode: this.state.param.operationMode,
      stubType: this.state.param.stubType,
      cityIds: this.state.param.cityIds,
      provinceIds: this.state.param.provinceIds,
      startTime: this.state.param.startTime,
      endTime: this.state.param.endTime,
    }).then((res) => {
      if (res.data) {
        //按照工单等级进行分组合并，用于饼图、柱状图和下面的人员数据展示  后台返回的是列表数据，列表是根据人员和工单类型分组的。
        var pieList = []; //故障信息
        var peopleData = []; //城市排名
        if (res.data.cityRankList != null && res.data.cityRankList.length > 0) {
          // cityName:'常州市',
          //       rankNum:1,
          //       rate:12.12,
          var index = 1;
          res.data.cityRankList.forEach(function (item) {
            var one = {};
            one.cityName = item.cityName;
            one.rate = item.rate.toFixed(2) + "%";
            one.rankNum = index;
            index++;
            peopleData.push(one);
          });
        }
        if (
          res.data.faultReportedQuantityDTOList != null &&
          res.data.faultReportedQuantityDTOList.length > 0
        ) {
          var i = 0;

          res.data.faultReportedQuantityDTOList.forEach(function (item) {
            var one = {
              ticketPriorityName: item.levenName,
              rate: item.proportion,
            };
            if (one.ticketPriorityName == "重大") {
              one.color = "#ff0000";
            } else if (one.ticketPriorityName == "严重") {
              one.color = "#9b7575";
            } else if (one.ticketPriorityName == "主要") {
              one.color = "#3c3535";
            } else if (one.ticketPriorityName == "次要") {
              one.color = "#240a0a";
            }
            pieList.push(one);
          });
        }

        this.setState({
          faultStubCount: res.data.faultStubCount,
          pieData: pieList,
          peopleData: peopleData,
        });
      }
    });
  }

  /**
   * 获取故障曲线
   */
  getTop10() {
    if (
      this.state.param.infoType != null &&
      (this.state.param.cityIds == null || this.state.param.cityIds == "") &&
      (this.state.param.provinceIds == null || this.state.param.provinceIds == "")
    ) {
      this.setState({
        monthDataList: [],
        comEvHandleNum: 0,
        evHandleNum: 0,
        handleNum: 0,
        finishNum: 0,
        newNum: 0,
      });
      return;
    }

    fetchHandler(qryErrorNumListByArea, {
      operationMode: this.state.param.operationMode,
      stubType: this.state.param.stubType,
      cityIds: this.state.param.cityIds,
      provinceIds: this.state.param.provinceIds,
      startTime: this.state.param.startTime,
      endTime: this.state.param.endTime,
    }).then((res) => {
      if (res.data) {
        // this.setState({
        //   peopleData:res.data
        // });
        if (res.data && res.data.length > 0) {
          localStorage.setItem("errorBoardData", JSON.stringify(res.data));
        } else {
          localStorage.setItem("errorBoardData", JSON.stringify([]));
        }

        this.setState({
          firmwareDataList: res.data,
        });
      }
    });
  }

  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList, { userId: sessionStorage.getItem("userId"), cityType: 1 }).then(
      (res) => {
        if (!res.data) {
          return;
        }
        const fetchPickerOptions = res.data;
        let formatOptionsStr = JSON.stringify(fetchPickerOptions);
        formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
        formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
        formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
        const cityAryy = JSON.parse(formatOptionsStr);
        cityAryy.map((item) => {
          item.key = item.value;
          item.children.map((item2) => {
            item2.key = item2.value;
            delete item2.children; // 删除子区域数据
            return true;
          });
          return true;
        });
        // 初始化城市数据
        this.quanguoCityArry = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];

        // 只能选择城市的方式
        this.quanguoCityNotP = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];
        this.quanguoCityNotP.map((item) => {
          item.disabled = true;
          item.children.map((item1) => {
            item1.disabled = true;
            item1.children.map((item2) => {
              item2.disabled = false;
              return true;
            });
            return true;
          });
          return true;
        });
        // 只能选择省份的数组
        this.quanguoCityNotCity = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];
        this.quanguoCityNotCity.map((item) => {
          item.disabled = true;
          item.children.map((item1) => {
            item1.disabled = false;
            item1.children.map((item2) => {
              item2.disabled = true;
              return true;
            });
            return true;
          });
          return true;
        });
        // 只能选择全国的数组
        this.quanguoCityNotChild = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];
        this.quanguoCityNotChild.map((item) => {
          item.disabled = false;
          item.children.map((item1) => {
            item1.disabled = true;
            item1.children.map((item2) => {
              item2.disabled = true;
              return true;
            });
            return true;
          });
          return true;
        });
        // 设置数据
        this.setState(
          {
            quanguoCityArry: [...this.quanguoCityArry],
          },
          () => {
            this.setState({
              formConfig: this.initForm(),
            });
          },
        );
      },
    );
  };

  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = "";
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (
        value[0].charAt(5) === "0" &&
        value[0].charAt(4) === "0" &&
        value[0].charAt(3) === "0" &&
        value[0].charAt(2) === "0"
      ) {
        quanguoCityArryCVal = this.quanguoCityNotCity;
      } else {
        quanguoCityArryCVal = this.quanguoCityNotP;
      }
      // 设置数据
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
  };

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
  };

  // 加载form方法
  initForm() {
    const formConfig = {
      childItems: [
        {
          type: "select",
          placeholder: "请选择",
          labelName: "运营类型",
          param: {
            name: "operationMode",
            type: "string",
          },
          options: this.state.ticketTypeList,
          allowClear: true,
          required: false,
        },
        {
          type: "select",
          placeholder: "请选择",
          labelName: "设备类型",
          param: {
            name: "stubType",
            type: "string",
          },
          options: this.state.levelTypeList,
          allowClear: true,
          required: false,
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择大区',
          labelName: "大区", // '大区',
          param: {
            name: "areaIds",
            type: "string",
          },
          options: this.state.areaList,
          allowClear: true,
          required: false,
          onChange: async (value, form) => {
            if (value == null || value == "") {
              //恢复区域信息
              form.setFieldsValue({
                cityGroup: [],
              });
            } else {
              //遍历区域，把不属于
              form.setFieldsValue({
                cityGroup: value.split(","),
              });
            }
            this.setState({
              formConfig: this.initForm(value),
            });
          },
        },
        {
          type: "select",
          placeholder: "请选择",
          labelName: "城市类别",
          param: {
            name: "infoType",
            type: "string",
          },
          options: this.state.cityTypeList,
          allowClear: true,
          required: false,
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },

        {
          type: "date",
          dateType: "rangeDate",
          placeholder: ["开始时间", "结束时间"],
          param: {
            name: "chooseDate",
            type: "array",
          },
          width: "200px",
          allowClear: false,
          defaultValue:
            !this.state.param.chooseDate || this.state.param.chooseDate === null
              ? [moment(new Date()).subtract(7, "d"), moment(new Date()).subtract(1, "d")]
              : [moment(this.state.param.chooseDate[0]), moment(this.state.param.chooseDate[1])],
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 365, // 最大可选天数
          }, // 自定义校验规则
          labelName: "日期", // '订单结束时间:',
          required: !1,
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              text: "查询",
              // icon: "search",
              handler: (e, param) => {
                console.info("群里");
                console.info(param);
                // 设置城市数组
                let cityIds = "";
                var infoType = param.infoType; //城市类别
                // 判断选择地区类型（全国、省份、城市）
                let cityType = "0"; // 0：全国，1：省份，2：城市
                if (param.cityGroup !== undefined) {
                  if (param.cityGroup.length === 0) {
                    console.info("问问3");
                    // cityIds = "000000";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (infoType && infoType != null) {
                          if (one.cityType == infoType) {
                            ids.push(one.key);
                          }
                        } else {
                          ids.push(one.key);
                        }
                      });
                    });
                    cityIds = ids.join(",");
                  } else if (param.cityGroup[0] === "000000") {
                    console.info("问问4");
                    // cityType = "0";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (infoType && infoType != null) {
                          if (one.cityType == infoType) {
                            ids.push(one.key);
                          }
                        } else {
                          ids.push(one.key);
                        }
                      });
                    });
                    cityIds = ids.join(",");
                  } else if (
                    param.cityGroup[0].charAt(5) === "0" &&
                    param.cityGroup[0].charAt(4) === "0" &&
                    param.cityGroup[0].charAt(3) === "0" &&
                    param.cityGroup[0].charAt(2) === "0"
                  ) {
                    console.info("问问5");
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      if (param.cityGroup.indexOf(item.key) != -1) {
                        item.children.forEach(function (one) {
                          if (infoType && infoType != null) {
                            if (one.cityType == infoType) {
                              ids.push(one.key);
                            }
                          } else {
                            ids.push(one.key);
                          }
                        });
                        item.children.forEach(function (one) {});
                      }
                    });
                    cityIds = ids.join(",");
                  } else {
                    console.info("问问6" + cityIds);
                    cityType = "2";
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (param.cityGroup.indexOf(one.key) != -1) {
                          if (infoType && infoType != null) {
                            if (one.cityType == infoType) {
                              cityIds += `${one.key},`;
                            }
                          } else {
                            cityIds += `${one.key},`;
                          }
                        }
                      });
                    });
                  }
                } else {
                  console.info("问问7");
                  var ids = [];
                  cityType = "2";
                  //省份下的城市 cityIds改成所选省份下的城市
                  this.state.quanguoCityArry[0].children.forEach(function (item) {
                    item.children.forEach(function (one) {
                      if (infoType && infoType != null) {
                        if (one.cityType == infoType) {
                          ids.push(one.key);
                        }
                      } else {
                        ids.push(one.key);
                      }
                    });
                  });
                  cityIds = ids.join(",");
                }
                var startTime = null;
                var endTime = null;
                if (
                  param.chooseDate != null &&
                  param.chooseDate != "" &&
                  param.chooseDate.length > 0
                ) {
                  startTime = param.chooseDate.split(",")[0];
                  endTime = param.chooseDate.split(",")[1];
                }
                this.setState(
                  {
                    param: {
                      cityIds: cityType === "2" ? cityIds || "" : "",
                      provinceIds: cityType === "0" || cityType === "1" ? cityIds || "000000" : "",
                      stubType: param.stubType,
                      operationMode: param.operationMode,
                      projectNames:
                        param.projectNames &&
                        param.projectNames != null &&
                        param.projectNames.length > 0
                          ? param.projectNames.join(",")
                          : null,
                      operationProperty: "3",
                      userId: param.userId,
                      infoType: param.infoType,
                      companyId: param.companyId,
                      startTime: startTime,
                      endTime: endTime,
                    },
                  },
                  () => {
                    // 查询订单累计数据
                    this.getEquipmentQry();
                    this.getTop10();
                  },
                );
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        operationProperty: "3",
      },
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "oprationLogTable",
    };

    return formConfig;
  }

  // style={{ "min-width": "1440px" }}
  render() {
    const content = (
      <div className="sc-page-content display-board-page">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} />
        </div>
        <div className="page-panel">
          <div className="display-board">
            <div className="item">
              <div className="inner" style={{ height: "421px" }}>
                <div style={{ fontSize: "18px", fontWeight: "600" }} className="line-title">
                  故障设备统计
                  <Tooltip
                    title={() => (
                      <span style={{ color: "#000" }}>
                        检索范围内发生故障的设备总数，按故障级别占比
                      </span>
                    )}
                    color="#ffffff"
                    overlayClassName="white-tooltip">
                    <QuestionCircleFilled
                      style={{
                        color: "#D9D9D9",
                        marginLeft: "4px",
                        top: "1px",
                      }}
                    />
                  </Tooltip>
                </div>
                <div
                  style={{
                    width: "200px",
                    height: "80px",
                    border: "1px solid #f2f3f5",
                    padding: "10px",
                    marginTop: "10px",
                  }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px",
                      marginRight: "5px",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                    }}>
                    <div>故障设备总数</div>
                    <div
                      style={{ color: "#5584ff", fontSize: "12px", cursor: "pointer" }}
                      onClick={() => {
                        this.getModalData(1, this.state.faultStubCount);
                      }}>
                      {" "}
                      详情
                      <RightOutlined />
                    </div>
                  </div>
                  <div style={{ fontSize: "14px" }}>{this.state.faultStubCount}</div>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <ErrorCountPl
                    getStubIntactRate={this.getStubIntactRate}
                    chartId="glllPieLLL"
                    pieType="1"
                    param={this.state.pieData}
                  />
                </div>
              </div>
            </div>

            <div className="item">
              <div className="inner" style={{ height: "421px" }}>
                <div style={{ fontSize: "18px", fontWeight: "600" }} className="line-title">
                  故障率TOP10城市排行榜
                  <Tooltip
                    title={() => (
                      <span style={{ color: "#000" }}>
                        检索范围内各个城市发生故障的设备数占各个城市设备总数的比例排名前10名
                      </span>
                    )}
                    color="#ffffff"
                    overlayClassName="white-tooltip">
                    <QuestionCircleFilled
                      style={{
                        color: "#D9D9D9",
                        marginLeft: "4px",
                        top: "1px",
                      }}
                    />
                  </Tooltip>
                </div>
                <div style={{ flex: 1 }}>
                  <ErrorTop10
                    getStubIntactRate={this.getStubIntactRate}
                    param={this.state.peopleData}
                  />
                </div>
              </div>
            </div>

            <div className="item daochu">
              <div className="inner" style={{ minHeight: "621px" }}>
                <div>
                  <ErrorGroup
                    {...this.props}
                    dataSource={this.state.firmwareDataList}
                    loading={this.state.firmwareLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          title={this.state.modalTitle}
          visible={this.state.statusLogVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("statusLogVisible", false);
          }}>
          <ErrorCityModal
            modalParam={this.state.param}
            stubIdData={this.state.areaDTOList}
            modalType={this.state.modalType}
            firstId={this.state.fAreaId}
            modalStationTitle={this.state.modalStationTitle}
            modalStationNum={this.state.modalStationNum}
          />
        </Modal>
      </div>
    );
    return content;
  }
}

export default injectIntl(ErrorPlat);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/errorPlat.js